// Shared Google Maps loader — ensures the API is loaded exactly once across the app.
// Prevents the "multiple times" error which corrupts google.maps internals.

let loadPromise = null;

export const loadGoogleMaps = () => {
  if (typeof window === 'undefined') return Promise.resolve(null);

  // Already loaded and initialised
  if (window.google && window.google.maps && window.google.maps.Map) {
    return Promise.resolve(window.google.maps);
  }

  // Load already in progress — reuse the same promise
  if (loadPromise) return loadPromise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY not configured'));
  }

  // If a Google Maps script tag already exists (from another component), wait for it
  const existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
  if (existing) {
    loadPromise = new Promise((resolve) => {
      const check = () => {
        if (window.google && window.google.maps && window.google.maps.Map) resolve(window.google.maps);
        else setTimeout(check, 100);
      };
      check();
    });
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Google Maps'));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
};
